import styled from "styled-components"

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.backgroundSecondary};
  padding: 4rem 2rem;
  text-align: center;
  color: ${({ theme }) => theme.textPrimary};
  width: 100%;
  scroll-margin-top: 120px;

  @media (max-width: 768px) {
    padding: 3rem 1.5rem;
  }
`

const ContentWrapper = styled.div`
  max-width: 800px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`

const Title = styled.h2`
  font-size: 2.2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.primaryDark};

  margin: 1rem 0;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`

const Paragraph = styled.p`
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
  color: ${({ theme }) => theme.textPrimary};

  strong {
    color: ${({ theme }) => theme.primaryDark};
  }

  em {
    font-style: italic;
    color: ${({ theme }) => theme.primary};
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`

const Signature = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  /* margin-top: 2rem; */
  gap: 0.5rem;
  font-size: 1rem;
  color: ${({ theme }) => theme.textPrimary};

  img {
    width: 210px;
    height: auto;
    margin-top: 1rem;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;

    img {
      width: 200px;
    }
  }
`

const EngagementSection = () => {
  return (
    <SectionWrapper id="approche-humaine">
      <ContentWrapper>
        <Title>Une gestion claire, à votre façon</Title>
        <Paragraph>
          Chaque immeuble a son histoire, ses occupants et ses priorités. Nous commençons donc par comprendre votre réalité avant de proposer une
          façon de travailler.
        </Paragraph>
        <Paragraph>
          Notre rôle est simple : vous donner une vue claire de ce qui se passe, coordonner les tâches convenues et rester disponibles quand une
          décision doit être prise. C’est ce que nous appelons une <em>gestion transparente, rigoureuse et humaine</em>.
        </Paragraph>
        <Signature>
          <span>Marco Tremblay</span>
          <img src="/img/signatureMarco.png" alt="Signature de Marco Tremblay" loading="lazy" />
        </Signature>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default EngagementSection
